import React from 'react'
import {
    Link
  } from "react-router-dom";

export default function Navbar({displaysidebar, linkAction}) {
    return (
        <div>
            <div class="container">
                        <div class="hamburger-menu" onClick={displaysidebar}>
                            <div class="line line-1"></div>
                            <div class="line line-2"></div>
                            <div class="line line-3"></div>
                            <span>Close</span>
                        </div>
                        

                        <section class="sidebar">
                            <ul class="menu">
                                <Link onClick={linkAction} to="/">
                                    <li class="menu-item">
                                        <a href="/" class="menu-link" data-content="Home">Home</a>
                                    </li>     
                                </Link>
                                
                                <Link onClick={linkAction} to="/about">
                                    <li class="menu-item">
                                        <a href="/" class="menu-link" data-content="About Us">About Us</a>
                                    </li>
                                </Link>
                                
                                
                                <Link onClick={linkAction} to="/team">
                                    <li class="menu-item">
                                        <a href="/" class="menu-link" data-content="Team">Team</a>
                                    </li>
                                </Link>
                                
                                
                                <Link onClick={linkAction} to="/vehicles">
                                <li class="menu-item">
                                        <a href="/" class="menu-link" data-content="Portfolio">Portfolio</a>
                                    </li>
                                </Link>
                                
                                <Link onClick={linkAction} to="/contact">
                                    <li class="menu-item">
                                        <a href="/" class="menu-link" data-content="Contact">Contact</a>
                                    </li>
                                </Link>
                            </ul>
                            <div class="social-media move">
                                <p>Need a website like this? </p>
                            </div>
                            <div class="social-media">
                                <a href="https://web.facebook.com/adeola.i.olutoke"><i class="fab fa-facebook-f"></i></a>
                                <a href="https://wa.me/+2348133773902"><i class="fab fa-whatsapp"></i></a>
                                <a href="https://twitter.com/ayamkumputa"><i class="fab fa-twitter"></i></a>
                            </div>
                        </section>
                </div>
        </div>
    )
}
